import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDesignTokens } from "../../../theme/useDesignTokens";

const AppCheckbox = ({
  checked = false,
  onChange,
  label,
  size = "small",
  color = "primary",
  disabled = false,
  icon,
  checkedIcon,
  sx = {},
  checkboxSx = {},
  labelSx = {},
  labelPlacement = "end",
  ...props
}) => {
  const { colors, font } = useDesignTokens();
  const primaryColor = colors?.primary?.main || "#ED6C02";

  const control = (
    <Checkbox
      checked={checked}
      onChange={onChange}
      size={size}
      color={color}
      disabled={disabled}
      icon={icon}
      checkedIcon={checkedIcon}
      sx={{
        color: color === "primary" ? primaryColor : undefined,
        "&.Mui-checked": {
          color: color === "primary" ? primaryColor : undefined,
        },
        ...checkboxSx,
      }}
      {...props}
    />
  );

  if (!label) {
    return control;
  }

  return (
    <FormControlLabel
      control={control}
      label={label}
      labelPlacement={labelPlacement}
      sx={{
        m: 0,
        alignItems: "center",
        "& .MuiFormControlLabel-label": {
          fontWeight: font?.weight?.fontW500,
          ...labelSx,
        },
        ...sx,
      }}
    />
  );
};

export default AppCheckbox;
